import { render } from "./WalletRefundDetail.vue?vue&type=template&id=0b61cbe1&scoped=true&ts=true"
import script from "./WalletRefundDetail.ts?vue&type=script&lang=ts"
export * from "./WalletRefundDetail.ts?vue&type=script&lang=ts"

import "./WalletRefundDetail.vue?vue&type=style&index=0&id=0b61cbe1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b61cbe1"]])

export default __exports__